let $sensors: any = {};

const modules = import.meta.glob("./modules/*.ts", { eager: true });

for (const [key, value] of Object.entries(modules)) {
  // 导入的模块默认导出的内容将被赋给utils对象的同名属性
  // var moduleName = key.replace(/^\.\/(.*)\.\w+$/,'$1');
  // const name = moduleName.split('/')[1]
  //如需要

  //具体的内容，都是每个is中返回值value.default
  $sensors = {
    ...$sensors,
    ...(value.default as any),
  };
}
export default $sensors;
